import { c as _c } from "react/compiler-runtime";
import './child-bio-sponsorship-submit-button.scss';
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { IntlBlock } from '@sola/ark-core/atoms/intl/Intl.tsx';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import type { ErrorCart } from '@sola/schema/dotcom/cart/errors.ts';
import type { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { trackError } from '@sola/tracking/lib/analytics/events.ts';

// TODO: Refactor to use for other calls to add items to the cart?
const BioErrors: React.FC<{
  errors: ErrorCart[];
}> = t0 => {
  const $ = _c(12);
  const {
    errors
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["bio", "checkout", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t,
    i18n
  } = useTranslation(t1);
  let t2;
  let t3;
  if ($[1] !== errors || $[2] !== i18n || $[3] !== t) {
    const errorTypesDisplayed = [];
    const errorsToDisplay = errors.reduce((displayErrors, err) => {
      if (!errorTypesDisplayed.includes(err.type)) {
        errorTypesDisplayed.push(err.type);
        return [...displayErrors, err];
      }
      return displayErrors;
    }, []);
    t2 = "flex flex-col gap-y-snug-xl mb-comfy-xl";
    let t4;
    if ($[6] !== i18n || $[7] !== t) {
      t4 = error => {
        trackError(JSON.stringify(error));
        const {
          type,
          severity
        } = error;
        const elKey = error.id;
        const hasMsg = i18n.exists(`checkout:errors.${type}.message`);
        const hasTitle = i18n.exists(`checkout:errors.${type}.title`);
        const message = hasMsg ? <IntlBlock i18nKey={`checkout:errors.${type}.message`} values={error} tOptions={{
          interpolation: {
            escapeValue: false
          }
        }} components={{
          anchor: <a />
        }} /> : t("checkout:errors.CART_GENERIC.message");
        const title = hasTitle ? <IntlBlock i18nKey={`checkout:errors.${type}.title`} values={error} tOptions={{
          interpolation: {
            escapeValue: false
          }
        }} /> : undefined;
        return (hasMsg || hasTitle) && <Alert key={elKey} variant={severity ?? "negative"} title={hasTitle && title} message={hasMsg && message} dismissible={false} />;
      };
      $[6] = i18n;
      $[7] = t;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = errorsToDisplay.map(t4);
    $[1] = errors;
    $[2] = i18n;
    $[3] = t;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export const SubmitButton = t0 => {
  const $ = _c(25);
  const {
    bioErrors,
    className,
    details,
    isSubmitting,
    handleSponsorshipSubmit,
    isSticky: t1
  } = t0;
  const isSticky = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["bio"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  let t3;
  if ($[1] !== className || $[2] !== isSticky) {
    t3 = cn("ChildBioSponsorshipSubmitButton", {
      "ChildBioSponsorshipSubmitButton--sticky fixed w-full sm:relative sm:w-fit bottom-0 left-0 flex-shrink-0 p-comfy-sm sm:p-none": isSticky
    }, className);
    $[1] = className;
    $[2] = isSticky;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== bioErrors) {
    t4 = bioErrors && <BioErrors errors={bioErrors} />;
    $[4] = bioErrors;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] !== handleSponsorshipSubmit || $[7] !== isSubmitting) {
    t5 = () => {
      if (!isSubmitting) {
        handleSponsorshipSubmit();
      }
    };
    t6 = () => {
      if (!isSubmitting) {
        handleSponsorshipSubmit();
      }
    };
    $[6] = handleSponsorshipSubmit;
    $[7] = isSubmitting;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== details || $[11] !== isSubmitting || $[12] !== t) {
    t7 = isSubmitting ? `${t("bio:processing")}...` : t("bio:sponsorButton", {
      childName: details.name.preferred,
      koreanName: details.hangul.preferred || details.name.preferred,
      interpolation: {
        escapeValue: false
      }
    });
    $[10] = details;
    $[11] = isSubmitting;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <button id="add-cdsp" className="w-full md:w-fit" type="button" onPointerUp={t5} onClick={t6}>{t7}</button>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== isSubmitting || $[19] !== t8) {
    t9 = <ButtonStyle variant="primary" isBusy={isSubmitting}>{t8}</ButtonStyle>;
    $[18] = isSubmitting;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t3 || $[22] !== t4 || $[23] !== t9) {
    t10 = <div className={t3}>{t4}{t9}</div>;
    $[21] = t3;
    $[22] = t4;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};